import {
  GET_CHART_DATA,
} from '../../actions/analytic';

export default function analytic(state = {}, action) {
  switch (action.type) {
    case GET_CHART_DATA:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/analytic/index.js